import profile1 from '../assets/profile1.png'
import profile2 from '../assets/profile2.png'

export const TestimonialsData = [
    {
        image : profile1,
        comment: " Great shopping experience. The website is easy to use and the products are amazing.",
        name: "Shees"
    },
    {
        image : profile2,
        comment: " Great shopping experience. The website is easy to use and the products are amazing.",
        name: "Hassan"
    },
    {
        image : profile1,
        comment: " Great shopping experience. The website is easy to use and the products are amazing.",
        name: "Abdullah"
    },
    {
        image : profile1,
        comment: " Great shopping experience. The website is easy to use and the products are amazing.",
        name: "Ahtisham"
    },
    {
        image : profile2,
        comment: " BGreat shopping experience. The website is easy to use and the products are amazing.",
        name: "Sameer"
    },
    {
        image : profile1,
        comment: " Great shopping experience. The website is easy to use and the products are amazing.",
        name: "Ali"
    }
]